function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { isElement, getPlatePluginWithOverrides, pipeOverrideProps } from '@udecode/plate-core';
import { isDeserializerEnabled, insertDeserializedFragment } from '@udecode/plate-serializer';
import { mergeDeepToNodes, normalizeDescendantsToDocumentFragment, createElementWithSlate } from '@udecode/plate-common';
import { jsx } from 'slate-hyperscript';
import { Text } from 'slate';
import { renderToStaticMarkup } from 'react-dom/server';

/**
 * Convert HTML string into HTML element.
 */
var htmlStringToDOMNode = function htmlStringToDOMNode(rawHtml) {
  var stripWhitespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var node = document.createElement('body');
  node.innerHTML = rawHtml;
  if (stripWhitespace) {
    node.innerHTML = node.innerHTML.replace(/(\r\n|\n|\r|\t)/gm, '');
  }
  return node;
};

/**
 * Deserialize HTML to break line.
 */
var deserializeHTMLToBreak = function deserializeHTMLToBreak(node) {
  if (node.nodeName === 'BR') {
    return '\n';
  }
};

/**
 * Deserialize HTML to Element.
 */

var deserializeHTMLToElement = function deserializeHTMLToElement(editor, _ref) {
  var plugins = _ref.plugins,
    element = _ref.element,
    children = _ref.children;
  var slateElement;
  var withoutChildren;
  plugins.some(function (_ref2) {
    var pluginDeserializers = _ref2.deserialize;
    var elementDeserializers = pluginDeserializers === null || pluginDeserializers === void 0 ? void 0 : pluginDeserializers(editor).element;
    if (!elementDeserializers) return;
    return elementDeserializers.some(function (deserializer) {
      var deserialized = deserializer.deserialize(element);
      if (!deserialized) return;
      slateElement = deserialized;
      withoutChildren = deserializer.withoutChildren;
      return true;
    });
  });
  if (slateElement) {
    var descendants = children;
    if (!descendants.length || withoutChildren) {
      descendants = [{
        text: ''
      }];
    }
    return jsx('element', slateElement, descendants);
  }
};

/**
 * Deserialize HTML body element to Fragment.
 */

var deserializeHTMLToFragment = function deserializeHTMLToFragment(_ref3) {
  var element = _ref3.element,
    children = _ref3.children;
  if (element.nodeName === 'BODY') {
    return jsx('fragment', {}, children);
  }
};

/**
 * Deserialize HTML to TDescendant[] with marks on Text.
 * Build the leaf from the leaf deserializers of each plugin.
 */
var deserializeHTMLToMarks = function deserializeHTMLToMarks(editor, _ref4) {
  var plugins = _ref4.plugins,
    element = _ref4.element,
    children = _ref4.children;
  var leaf = {};
  plugins.forEach(function (_ref5) {
    var pluginDeserializers = _ref5.deserialize;
    var leafDeserializers = pluginDeserializers === null || pluginDeserializers === void 0 ? void 0 : pluginDeserializers(editor).leaf;
    if (!leafDeserializers) return;
    leafDeserializers.forEach(function (deserializer) {
      var leafPart = deserializer.deserialize(element);
      if (!leafPart) return;
      leaf = _objectSpread(_objectSpread({}, leaf), leafPart);
    });
  });
  return children.reduce(function (arr, child) {
    if (!child) return arr;
    if (isElement(child)) {
      if (Object.keys(leaf).length) {
        mergeDeepToNodes({
          node: child,
          source: leaf,
          query: {
            filter: function filter(_ref6) {
              var _ref7 = _slicedToArray(_ref6, 1),
                n = _ref7[0];
              return Text.isText(n);
            }
          }
        });
      }
      arr.push(child);
    } else {
      arr.push(jsx('text', leaf, child));
    }
    return arr;
  }, []);
};

/**
 * Deserialize HTML text node to text.
 */
var deserializeHTMLToText = function deserializeHTMLToText(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.nodeValue === '\n' ? null : node.textContent;
  }
};

/**
 * Deserialize HTML element or child node.
 */

var deserializeHTMLNode = function deserializeHTMLNode(editor, plugins) {
  return function (node) {
    var _node$childNodes$;

    // text node
    var textNode = deserializeHTMLToText(node);
    if (textNode) return textNode; // if not an element node

    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    var htmlElement = node; // break line

    var breakLine = deserializeHTMLToBreak(node);
    if (breakLine) return breakLine;
    var nodeName = node.nodeName;
    var parent = node; // blockquote

    if (nodeName === 'PRE' && ((_node$childNodes$ = node.childNodes[0]) === null || _node$childNodes$ === void 0 ? void 0 : _node$childNodes$.nodeName) === 'CODE') {
      var _node$childNodes = _slicedToArray(node.childNodes, 1);
      parent = _node$childNodes[0];
    }
    var children = Array.from(parent.childNodes).map(deserializeHTMLNode(editor, plugins)).flat(); // body

    var fragment = deserializeHTMLToFragment({
      element: htmlElement,
      children: children
    });
    if (fragment) return fragment; // element

    var element = deserializeHTMLToElement(editor, {
      plugins: plugins,
      element: htmlElement,
      children: children
    });
    if (element) return element; // mark

    return deserializeHTMLToMarks(editor, {
      plugins: plugins,
      element: htmlElement,
      children: children
    });
  };
};

/**
 * Deserialize HTML element.
 */

var deserializeHTMLElement = function deserializeHTMLElement(editor, _ref8) {
  var plugins = _ref8.plugins,
    element = _ref8.element;
  return deserializeHTMLNode(editor, plugins)(element);
};

/**
 * Deserialize HTML element to a valid document fragment.
 */

var deserializeHTMLToDocumentFragment = function deserializeHTMLToDocumentFragment(editor, _ref9) {
  var plugins = _ref9.plugins,
    element = _ref9.element,
    _ref9$stripWhitespace = _ref9.stripWhitespace,
    stripWhitespace = _ref9$stripWhitespace === void 0 ? true : _ref9$stripWhitespace;
  if (typeof element === 'string') {
    element = htmlStringToDOMNode(element, stripWhitespace);
  }
  var fragment = deserializeHTMLElement(editor, {
    plugins: plugins,
    element: element
  });
  return normalizeDescendantsToDocumentFragment(editor, {
    descendants: fragment
  });
};
var htmlDeserializerId = 'HTML Deserializer';
/**
 * Enables support for deserializing inserted content from HTML format to Slate format.
 */

var withDeserializeHTML = function withDeserializeHTML() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref10$plugins = _ref10.plugins,
    plugins = _ref10$plugins === void 0 ? [] : _ref10$plugins;
  return function (editor) {
    var insertData = editor.insertData;
    editor.insertData = function (data) {
      var html = data.getData('text/html');
      var isEnabled = isDeserializerEnabled(editor, plugins, htmlDeserializerId);
      if (html && isEnabled) {
        var _DOMParser$parseFromS = new DOMParser().parseFromString(html, 'text/html'),
          body = _DOMParser$parseFromS.body;
        var fragment = deserializeHTMLToDocumentFragment(editor, {
          plugins: plugins,
          element: body
        });
        if (fragment.length) {
          return insertDeserializedFragment(editor, {
            fragment: fragment,
            plugins: plugins
          });
        }
      }
      insertData(data);
    };
    return editor;
  };
};
/**
 * @see {@link withDeserializeHTML}
 */

var createDeserializeHTMLPlugin = getPlatePluginWithOverrides(withDeserializeHTML);

// Remove extra whitespace generated by ReactDOMServer
var trimWhitespace = function trimWhitespace(rawHtml) {
  return rawHtml.replace(/(\r\n|\n|\r|\t)/gm, '');
}; // Remove redundant data attributes

var stripSlateDataAttributes = function stripSlateDataAttributes(rawHtml) {
  return rawHtml.replace(/( data-slate)(-node|-type|-leaf)="[^"]+"/gm, '').replace(/( data-testid)="[^"]+"/gm, '');
};
/**
 * Remove all class names that do not start with one of preserveClassNames (`slate-` by default)
 */

var stripClassNames = function stripClassNames(html, _ref11) {
  var _ref11$preserveClassN = _ref11.preserveClassNames,
    preserveClassNames = _ref11$preserveClassN === void 0 ? ['slate-'] : _ref11$preserveClassN;
  var allClasses = html.split(/(class="[^"]*")/g);
  var filteredHtml = '';
  allClasses.forEach(function (item, index) {
    if (index % 2 === 0) {
      return filteredHtml += item;
    }
    var preserveRegExp = new RegExp(preserveClassNames.map(function (cn) {
      return "".concat(cn, "[^\"\\s]*");
    }).join('|'), 'g');
    var slateClassNames = item.match(preserveRegExp);
    if (slateClassNames) {
      filteredHtml += "class=\"".concat(slateClassNames.join(' '), "\"");
    }
  });
  return filteredHtml;
};
var getNode = function getNode(editor, _ref12) {
  var plugins = _ref12.plugins,
    elementProps = _ref12.elementProps,
    slateProps = _ref12.slateProps,
    preserveClassNames = _ref12.preserveClassNames;
  // If no type provided we wrap children with div tag
  if (!elementProps.element.type) {
    return "<div>".concat(elementProps.children, "</div>");
  }
  var html;
  var overriders = plugins.flatMap(function (plugin) {
    var _plugin$overrideProps, _plugin$overrideProps2;
    return (_plugin$overrideProps = (_plugin$overrideProps2 = plugin.overrideProps) === null || _plugin$overrideProps2 === void 0 ? void 0 : _plugin$overrideProps2.call(plugin, editor)) !== null && _plugin$overrideProps !== void 0 ? _plugin$overrideProps : [];
  });
  elementProps = pipeOverrideProps(elementProps, overriders); // Search for matching plugin based on element type

  plugins.some(function (plugin) {
    var _plugin$serialize, _plugin$deserialize, _plugin$deserialize$c, _plugin$serialize$ele, _plugin$serialize2, _plugin$serialize2$el, _plugin$renderElement;
    if (!((_plugin$serialize = plugin.serialize) !== null && _plugin$serialize !== void 0 && _plugin$serialize.element) && !plugin.renderElement) return false;
    if (!((_plugin$deserialize = plugin.deserialize) !== null && _plugin$deserialize !== void 0 && (_plugin$deserialize$c = _plugin$deserialize.call(plugin, editor).element) !== null && _plugin$deserialize$c !== void 0 && _plugin$deserialize$c.some(function (item) {
      return item.type === String(elementProps.element.type);
    }))) {
      html = "<div>".concat(elementProps.children, "</div>");
      return false;
    } // Render element using picked plugins renderElement function and ReactDOM

    html = renderToStaticMarkup(createElementWithSlate(_objectSpread(_objectSpread({}, slateProps), {}, {
      children: (_plugin$serialize$ele = (_plugin$serialize2 = plugin.serialize) === null || _plugin$serialize2 === void 0 ? void 0 : (_plugin$serialize2$el = _plugin$serialize2.element) === null || _plugin$serialize2$el === void 0 ? void 0 : _plugin$serialize2$el.call(_plugin$serialize2, elementProps)) !== null && _plugin$serialize$ele !== void 0 ? _plugin$serialize$ele : (_plugin$renderElement = plugin.renderElement) === null || _plugin$renderElement === void 0 ? void 0 : _plugin$renderElement.call(plugin, editor)(elementProps)
    })));
    html = stripClassNames(html, {
      preserveClassNames: preserveClassNames
    });
    return true;
  });
  return html;
};
var getLeaf = function getLeaf(editor, _ref13) {
  var plugins = _ref13.plugins,
    leafProps = _ref13.leafProps,
    slateProps = _ref13.slateProps,
    preserveClassNames = _ref13.preserveClassNames;
  var _leafProps = leafProps,
    children = _leafProps.children;
  return plugins.reduce(function (result, plugin) {
    var _plugin$serialize3, _plugin$serialize$lea, _plugin$serialize4, _plugin$serialize4$le, _plugin$renderLeaf, _plugin$serialize$lea2, _plugin$serialize5, _plugin$serialize5$le, _plugin$renderLeaf2;
    if (!((_plugin$serialize3 = plugin.serialize) !== null && _plugin$serialize3 !== void 0 && _plugin$serialize3.leaf) && !plugin.renderLeaf) return result;
    if (((_plugin$serialize$lea = (_plugin$serialize4 = plugin.serialize) === null || _plugin$serialize4 === void 0 ? void 0 : (_plugin$serialize4$le = _plugin$serialize4.leaf) === null || _plugin$serialize4$le === void 0 ? void 0 : _plugin$serialize4$le.call(_plugin$serialize4, leafProps)) !== null && _plugin$serialize$lea !== void 0 ? _plugin$serialize$lea : (_plugin$renderLeaf = plugin.renderLeaf) === null || _plugin$renderLeaf === void 0 ? void 0 : _plugin$renderLeaf.call(plugin, editor)(leafProps)) === children) return result;
    var overriders = plugins.flatMap(function (p) {
      var _p$overrideProps, _p$overrideProps2;
      return (_p$overrideProps = (_p$overrideProps2 = p.overrideProps) === null || _p$overrideProps2 === void 0 ? void 0 : _p$overrideProps2.call(p, editor)) !== null && _p$overrideProps !== void 0 ? _p$overrideProps : [];
    });
    leafProps = _objectSpread(_objectSpread({}, pipeOverrideProps(leafProps, overriders)), {}, {
      children: encodeURIComponent(result)
    });
    var html = decodeURIComponent(renderToStaticMarkup(createElementWithSlate(_objectSpread(_objectSpread({}, slateProps), {}, {
      children: (_plugin$serialize$lea2 = (_plugin$serialize5 = plugin.serialize) === null || _plugin$serialize5 === void 0 ? void 0 : (_plugin$serialize5$le = _plugin$serialize5.leaf) === null || _plugin$serialize5$le === void 0 ? void 0 : _plugin$serialize5$le.call(_plugin$serialize5, leafProps)) !== null && _plugin$serialize$lea2 !== void 0 ? _plugin$serialize$lea2 : (_plugin$renderLeaf2 = plugin.renderLeaf) === null || _plugin$renderLeaf2 === void 0 ? void 0 : _plugin$renderLeaf2.call(plugin, editor)(leafProps)
    }))));
    html = stripClassNames(html, {
      preserveClassNames: preserveClassNames
    });
    return html;
  }, children);
};
var isEncoded = function isEncoded() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  try {
    return str !== decodeURIComponent(str);
  } catch (error) {
    return false;
  }
};
/**
 * Convert Slate Nodes into HTML string
 */

var serializeHTMLFromNodes = function serializeHTMLFromNodes(editor, _ref14) {
  var plugins = _ref14.plugins,
    nodes = _ref14.nodes,
    slateProps = _ref14.slateProps,
    _ref14$stripDataAttri = _ref14.stripDataAttributes,
    stripDataAttributes = _ref14$stripDataAttri === void 0 ? true : _ref14$stripDataAttri,
    preserveClassNames = _ref14.preserveClassNames,
    _ref14$stripWhitespac = _ref14.stripWhitespace,
    stripWhitespace = _ref14$stripWhitespac === void 0 ? true : _ref14$stripWhitespac;
  var result = nodes.map(function (node) {
    if (Text.isText(node)) {
      return getLeaf(editor, {
        plugins: plugins,
        leafProps: {
          leaf: node,
          text: node,
          children: isEncoded(node.text) ? node.text : encodeURIComponent(node.text),
          attributes: {
            'data-slate-leaf': true
          }
        },
        slateProps: slateProps,
        preserveClassNames: preserveClassNames
      });
    }
    return getNode(editor, {
      plugins: plugins,
      elementProps: {
        element: node,
        children: encodeURIComponent(serializeHTMLFromNodes(editor, {
          plugins: plugins,
          nodes: node.children,
          preserveClassNames: preserveClassNames,
          stripWhitespace: stripWhitespace
        })),
        attributes: {
          'data-slate-node': 'element',
          ref: null
        }
      },
      slateProps: slateProps,
      preserveClassNames: preserveClassNames
    });
  }).join('');
  if (isEncoded(result)) {
    result = decodeURIComponent(result);
  }
  if (stripWhitespace) {
    result = trimWhitespace(result);
  }
  if (stripDataAttributes) {
    result = stripSlateDataAttributes(result);
  }
  return result;
};
export { createDeserializeHTMLPlugin, deserializeHTMLElement, deserializeHTMLNode, deserializeHTMLToBreak, deserializeHTMLToDocumentFragment, deserializeHTMLToElement, deserializeHTMLToFragment, deserializeHTMLToMarks, deserializeHTMLToText, htmlDeserializerId, htmlStringToDOMNode, serializeHTMLFromNodes, withDeserializeHTML };